<template>
    <div class="interment-edit-wrapper">
        <form autocomplete="off" method="post" :data-vv-scope="vScope" @keyup.enter="() => {return false;}" @submit.prevent="() => {return false;}">
            <div class="row" v-if="isNew">
                <div class="col-12">
                    <IntermentLocation
                        v-model="form"
                        :additional="additional"
                        :panelCfg="panelCfg"
                        :vScope="vScope"
                        :readonlyForm="readonlyForm"
                        :baseTranslateID="baseTranslateID"
                        :cemeteries="cemeteries"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-sm-12">
                    <div class="row">
                        <div
                            v-for="(item) in itemsForm"
                            :key="`interment-${item.key}-wrapper`"
                            :class="`col-12 col-md-12 col-lg-6 accordion interment-${item.key}-wrapper`">
                            <div class="card">
                                <div class="card-header" :id="`heading-interment-${item.key}`">
                                    <button
                                        type="button"
                                        :class="`btn btn-link btn-block interment-header`"
                                        :aria-expanded="`${item?.expanded ?? false }`"
                                        data-toggle="collapse"
                                        :data-target="`#collapse-interment-${item.key}`"
                                        :aria-controls="`#collapse-interment-${item.key}`">
                                        <h3 class="interment-panel-title">
                                            <span>{{ $t(`${modelTranslateID}.${item.key}.title`) }}</span>
                                        </h3>
                                        <div :class="`interment-panel-desc`">
                                            <i class="fas fa-chevron-right"></i>
                                        </div>
                                    </button>
                                </div>
                                <div
                                    :id="`collapse-interment-${item.key}`"
                                    :class="['collapse', {'show': item?.expanded ?? false}]"
                                    :aria-labelledby="`heading-interment-${item.key}`">
                                    <div class="card-body">
                                        <div :class="`interment-${item.key}-content`">
                                            <component
                                                v-bind:is="item.component"
                                                v-model="item.model"
                                                :additional="additional"
                                                :panelCfg="panelCfg"
                                                :vScope="vScope"
                                                :readonlyForm="readonlyForm"
                                                :baseTranslateID="baseTranslateID"
                                                :interment_types="interment_types"
                                                :container_types="container_types"
                                                :genders="genders"
                                                :religions="religions"
                                                :causes_death="causes_death"
                                                />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="col-12 col-sm-4">

                </div> -->
            </div>
        </form>
    </div>
</template>

<script>
import FormMixin from "./mixins/FormMixin";

export default {
    mixins: [
        FormMixin,
    ],
    components: {
        IntermentLocation: () => import(/* webpackChunkName: "cemeteries-interment-location" */ './elements/IntermentLocation'),
        IntermentEntity: () => import(/* webpackChunkName: "cemeteries-interment-entity" */ './elements/IntermentEntity'),
        IntermentDetails: () => import(/* webpackChunkName: "cemeteries-interment-details" */ './elements/IntermentDetails'),
        IntermentStory: () => import(/* webpackChunkName: "cemeteries-interment-story" */ './elements/IntermentStory'),
        IntermentFiles: () => import(/* webpackChunkName: "cemeteries-interment-files" */ './elements/IntermentFiles'),
    },
    props: {
        cemeteries: {
            type: Array,
            default: () => {return [];},
        },
        interment_types: {
            type: Array,
            default: () => {return [];},
        },
        container_types: {
            type: Array,
            default: () => {return [];},
        },
        genders: {
            type: Array,
            default: () => {return [];},
        },
        religions: {
            type: Array,
            default: () => {return [];},
        },
        causes_death: {
            type: Array,
            default: () => {return [];},
        },
    },
    data() {
        let idPanel = 'interment';
        return {
            idPanel: idPanel,
        }
    },
    computed: {
        itemsForm() {
            return [
                {key: 'entity', component: `IntermentEntity`, model: this.form?.entity, expanded: true, class: 'col-md-12 col-lg-6'},
                {key: 'details', component: `IntermentDetails`, model: this.form, expanded: true, class: 'col-md-12 col-lg-6'},
                {key: 'story', component: `IntermentStory`, model: this.form, class: 'col-sm-8'},
                {key: 'files', component: `IntermentFiles`, model: this.form.files, class: 'col-sm-4'},
            ];
        },
        isNew() {
            return !this.form?.id;
        }
    },
    methods: {

    },
    watch: {
        form: {
            deep: true,
            handler: function(value, oldValue){
                if(value && value?.entity) {
                    value.entity_id = value.entity.id;
                }
                this.$emit('input', value);
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.accordion {
    margin-bottom: 25px;

    .card {
        border: 1px solid rgba(24, 20, 41, .2) !important;
        border-radius: 8px;

        .card-header {
            margin: 0;
            padding: 0;
            border-bottom: none;
            background-color: transparent;

            .btn {
                min-width: auto;
                background-color: #fff;
                padding: 16px;

                &:focus,
                &:hover {
                    outline: 0;
                    box-shadow: none;
                    text-decoration: none;
                }

                &:hover:not([aria-expanded=true]) {
                    background: rgba(0, 0, 0, .04);
                }
            }

            .interment-header{
                display: flex;
                flex: 1;
                -webkit-box-pack: justify;
                -ms-flex-pack: justify;
                justify-content: space-between;
                overflow: hidden;

                .interment-panel-title {
                    color: #181429;
                    margin-bottom: 0;
                    font-family: var(--city-medium-font-family);
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 24px;
                    text-transform: capitalize;
                }

                .interment-panel-desc {
                    margin-right: 0;
                    display: flex;
                    color: var(--primary-color);
                    font-size: 17px;
                    cursor: pointer;

                    i {
                        width: 24px;
                        height: 24px;
                    }
                }

                &[aria-expanded=true] {
                    .interment-panel-desc {
                        display: none;
                    }
                }
            }
        }

        .card-body {
            padding-top: 0;
        }
    }
}
</style>